import React, { Component } from 'react';
import { connect } from 'react-redux';

import Modal from '../../../../components/Modal';
import LoadMask from '../../../../components/LoadMask';
import { getAddPlatformUserUI } from '../../../../redux/selectors';
import { fetchPlatformUsers, fetchAddPlatformUser, addPlatformUserClear } from '../../../../redux/admin-platform-users';

import PlatformUserForm from './PlatformUserForm';

class AddPlatformUserModal extends Component {
  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(addPlatformUserClear());
  }

  _submit = ({
    name,
    email,
    companyId,
    roles,
    divisions,
    isCustomerService,
  }) => {
    const { dispatch, onDismiss } = this.props;

    dispatch(fetchAddPlatformUser(name, email, companyId, divisions, roles, isCustomerService)).then(
      () => {
        onDismiss();
        dispatch(fetchPlatformUsers());
      },
      // reject
      () => { },
    );
  }

  render() {
    const { onDismiss, companies, ui } = this.props;

    return (
      <Modal
        title="Novo Usuário"
        size="small"
        onBackdropClick={onDismiss}
      >
        <PlatformUserForm
          errorMessage={ui.error}
          companies={companies}
          onDismiss={onDismiss}
          onSubmit={this._submit}
        />
        {
          ui.isFetching &&
          <LoadMask text="Salvando..." />
        }
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    ui: getAddPlatformUserUI(state),
  };
}

export default connect(mapStateToProps)(AddPlatformUserModal);
